// extracted by mini-css-extract-plugin
module.exports = {"centre":"Results_centre___3MfB"};